import { createSlice } from "@reduxjs/toolkit";
import getInvoiceApi from "@custom/rtk-apis/billing/invoice/getInvoice";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:"",
  pagination: null,
};

const getInvoiceSlice = createSlice({
  name: "getInvoiceSlice",
  initialState,
  reducers: {
    clearGetInvoice: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
      state.pagination = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInvoiceApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getInvoiceApi.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.data;
        state.msg = payload.msg;
        state.pagination = payload.pagination || null;
      })
      .addCase(getInvoiceApi.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
        state.pagination = null;
        state.error = payload instanceof Error ? payload.message : "Unknown error";
      });
  },
});

export default getInvoiceSlice.reducer;
export const { clearGetInvoice } = getInvoiceSlice.actions;
